import getSurfaceStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator action to set isReadingPaneVisible to true
 */
export const openReadingPaneSurfaceMutator = mutatorAction('openReadingPaneSurfaceMutator', () => {
    getSurfaceStore().isReadingPaneVisible = true;
});

/**
 * Mutator action to set isReadingPaneVisible to false
 */
export const closeReadingPaneSurfaceMutator = mutatorAction(
    'closeReadingPaneSurfaceMutator',
    () => {
        getSurfaceStore().isReadingPaneVisible = false;
    }
);
